// import { useState } from "react";
// import { Plus, Minus, X } from "lucide-react";
// import { formatPrice } from "../utils/helper";

// export default function AddToCartModal({ product, onClose, onConfirm }) {
//   const [quantity, setQuantity] = useState(1);

//   const handleConfirm = () => {
//     onConfirm(quantity);
//     onClose();
//   };

//   return (
//     <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
//       <div className="bg-white rounded-xl p-6 w-80 relative text-[#7a6e5f]">
//         {/* Close Button */}
//         <button onClick={onClose} className="absolute top-3 right-3 text-[#7a6e5f] hover:text-[#809080]">
//           <X className="w-5 h-5" />
//         </button>

//         {/* Product Info */}
//         <div className="text-center mb-6">
//           <h2 className="text-2xl font-serif font-bold mb-2">{product.name}</h2>
//           <p className="text-[#809080] font-medium mb-2">{formatPrice(product.price)}</p>
//           <img src={product.image} alt={product.name} className="h-32 w-32 object-cover mx-auto rounded-md" />
//         </div>

//         {/* Quantity Control */}
//         <div className="flex items-center justify-center gap-4 mb-6">
//           <button
//             onClick={() => setQuantity((prev) => Math.max(1, prev - 1))}
//             className="p-2 rounded-full bg-[#f5eee6] hover:bg-[#e8dfd3]"
//           >
//             <Minus className="w-5 h-5" />
//           </button>
//           <span className="text-xl font-semibold">{quantity}</span>
//           <button
//             onClick={() => setQuantity((prev) => prev + 1)}
//             className="p-2 rounded-full bg-[#f5eee6] hover:bg-[#e8dfd3]"
//           >
//             <Plus className="w-5 h-5" />
//           </button>
//         </div>

//         {/* Confirm Button */}
//         <button
//           onClick={handleConfirm}
//           className="w-full bg-[#809080] hover:bg-[#6d7d6d] text-white py-2 rounded-md transition"
//         >
//           Add to Cart
//         </button>
//       </div>
//     </div>
//   );
// }

import { useState } from "react";
import { Plus, Minus, X } from "lucide-react";
import { formatPrice } from "../utils/helper";

export default function AddToCartModal({ product, onClose, onConfirm }) {
  const [quantity, setQuantity] = useState(1);
  const [selectedVariant, setSelectedVariant] = useState(null);

  const handleConfirm = () => {
    // If product has variants, ensure one is selected
    if (product.variants && product.variants.length > 0 && !selectedVariant) {
      alert("Please select a variant.");
      return;
    }

    const finalItem =
      product.variants && product.variants.length > 0
        ? { ...product, id: selectedVariant.id, selectedVariant }
        : product;

    onConfirm(quantity, finalItem);
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl p-6 w-96 max-w-[90%] relative text-[#7a6e5f]">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-[#7a6e5f] hover:text-[#809080]"
        >
          <X className="w-5 h-5" />
        </button>

        {/* Product Info */}
        <div className="text-center mb-6">
          <h2 className="text-2xl font-serif font-bold mb-2">{product.name}</h2>
          <p className="text-[#809080] font-medium mb-2">
            {formatPrice(product.price)}
          </p>
          <img
            src={`${process.env.REACT_APP_API_URL}/storage/${product.image}`}
            alt={product.name}
            className="h-32 w-32 object-cover mx-auto rounded-md"
          />
        </div>

        {/* Variant Selection or Info */}
        <div className="mb-6">
          {product.variants && product.variants.length > 0 ? (
            <>
              <h3 className="font-semibold mb-2 text-sm">Select a Variant</h3>
              <div className="grid grid-cols-3 gap-3">
                {product.variants.map((variant) => {
                  const isSelected = selectedVariant?.id === variant.id;
                  return (
                    <button
                      key={variant.id}
                      onClick={() => setSelectedVariant(variant)}
                      className={`flex flex-col items-center justify-center p-2 border rounded-md text-sm transition-all duration-200 ${
                        isSelected
                          ? "border-[#809080] bg-[#f5eee6]"
                          : "border-[#f5eee6]"
                      }`}
                    >
                      <img
                        src={`${process.env.REACT_APP_API_URL}/storage/${variant.image}`}
                        alt={variant.variant_name}
                        className="w-12 h-12 object-cover rounded mb-1"
                      />
                      {variant.variant_name}
                    </button>
                  );
                })}
              </div>
            </>
          ) : (
            <div className="bg-[#f5eee6] text-sm rounded-md p-4 text-center">
              This product comes in one perfect version—no need to choose a
              variant ✨
            </div>
          )}
        </div>

        {/* Quantity Control */}
        <div className="flex items-center justify-center gap-4 mb-6">
          <button
            onClick={() => setQuantity((prev) => Math.max(1, prev - 1))}
            className="p-2 rounded-full bg-[#f5eee6] hover:bg-[#e8dfd3]"
          >
            <Minus className="w-5 h-5" />
          </button>
          <span className="text-xl font-semibold">{quantity}</span>
          <button
            onClick={() => setQuantity((prev) => prev + 1)}
            className="p-2 rounded-full bg-[#f5eee6] hover:bg-[#e8dfd3]"
          >
            <Plus className="w-5 h-5" />
          </button>
        </div>

        {/* Confirm Button */}
        <button
          onClick={handleConfirm}
          className="w-full bg-[#809080] hover:bg-[#6d7d6d] text-white py-3 rounded-md transition"
        >
          Add to Cart
        </button>
      </div>
    </div>
  );
}
